import "./YoutubePlayer.css";

import { getYoutubeId } from "../../../utils";

interface YoutubePlayerProps {
  videoUrl: string;
}

export const YoutubePlayer = ({ videoUrl }: YoutubePlayerProps): JSX.Element => {
  const videoId = getYoutubeId(videoUrl);
  const src = `https://www.youtube.com/embed/${videoId}`;

  return (
    <div className="YoutubePlayerContainer">
      {/* YouTube rejects embeds without a Referer (error 153), so override any stricter site-wide policy */}
      <iframe title="YoutubePlayer" src={src} allow="fullscreen" referrerPolicy="strict-origin-when-cross-origin" />
    </div>
  );
};
